import Dropdown from '@/components/atoms/dropdown';
import DropdownButton from '@/components/atoms/dropdown/components/button';
import DropdownOption from '@/components/atoms/dropdown/components/option';
import DropdownOptions from '@/components/atoms/dropdown/components/options';
import Typography from '@/components/atoms/typography';
import { BeakerIcon, BellAlertIcon, BookmarkIcon, CheckCircleIcon } from '@heroicons/react/24/solid';
import { Variant } from '@shared/types/product/Variant';
import React from 'react';
import Image from '@/components/atoms/Image';
import { PDP_SELECTED_VARIANT } from '@/constants/events';
import useAccount from '@/lib/hooks/useAccount';

const VariantSelector = ({ variants, currentVariantIndex, handleColorClick }: any) => {
  variants?.sort((a: any, b: any) => a?.attributes?.colour?.localeCompare(b.attributes.colour));
  const { account } = useAccount();

  const getVariantLabel = (v: any) =>
    v?.attributes?.['variant-name'] ||
    v?.attributes?.['item-attributes']?.find((a: any) => a?.name === 'colour')?.value ||
    '';

  const allNotApplicable = variants?.every(
    (v: any) => getVariantLabel(v).trim().toLowerCase() === 'not applicable',
  );
  // const applicableVariants =
  //   variants?.filter((v: any) => getVariantLabel(v).trim().toLowerCase() !== 'not applicable') ?? [];

  if (allNotApplicable) return null;
  //if (!applicableVariants.length) return null;

  const renderColorOptions = () => {
    return variants.map((variant: any, index: any) => {
      if (getVariantLabel(variant).trim().toLowerCase() === 'not applicable') return null;

      const colorAttribute = variant?.attributes?.['item-attributes']?.find(
        (attr: { name: string }) => attr?.name === 'colour',
      );
      const isSelected = variant?.id === currentVariantIndex?.id;
      const optionClassName = `color-option cursor-pointer ${isSelected
        ? 'selected border-b border-[#828282] text-sm font-semibold text-black py-2.5 items-center hover:bg-[#F3EDE9]'
        : 'border-b border-[#828282] text-sm font-semibold text-black py-2.5 items-center hover:bg-[#F3EDE9]'
        }`;
      const colorImageURL = `/images/Caroma_${colorAttribute?.value.replace(/\//g, ' ')}_POSITIVE.png`;
      return (
        <div
          key={variant?.id}
          className={optionClassName}
          onClick={() => {
            handleColorClick(index);
            //const originalIndex = variants.findIndex((v: any) => v.sku === variant.sku);
            //handleColorClick(originalIndex);
            handleVariantClick(variant);
          }}
          style={isSelected ? { display: 'flex' } : { display: 'flex' }}
        >
          <img src={colorImageURL} alt={variant?.attributes?.['variant-name'] || colorAttribute?.value} className="ml-2 mr-2 h-6 w-6 object-none" />
          {variant?.attributes?.['variant-name'] || colorAttribute?.value}
          {isSelected && <CheckCircleIcon className="ml-2 h-5 w-5" />}
        </div>
      );
    });
  };

  // const handleVariantClick = (clickedVariant: any) => {
  //   gtag('event', PDP_SELECTED_VARIANT, 'selected sku: ' + clickedVariant.sku);
  // };
  const handleVariantClick = (clickedVariant: any) => {
    if (typeof window !== 'undefined') {
      window.dataLayer = window.dataLayer as any || [] as any;
      window.dataLayer.push({
        'event': PDP_SELECTED_VARIANT,
        'selected sku: ': clickedVariant?.sku,
        "userId": account?.accountId
      });
    }
  };

  return (
    <>
      <Typography className="variantselector-text text-xs !font-medium uppercase !leading-4 text-[#090909]">
        VARIANT
      </Typography>
      <Dropdown className="variantselector-dropdown mt-1 lg:mt-2 w-full lg:w-[240px]">
          <DropdownButton>
            <div className="flex cursor-pointer items-center text-sm font-semibold text-black">
              <img
                src={`/images/Caroma_${currentVariantIndex?.attributes['item-attributes']
                  ?.find((attr: { name: string }) => attr.name === 'colour')
                  .value.replace('/', ' ')}_POSITIVE.png`}
                alt={
                  currentVariantIndex?.attributes?.['variant-name'] || currentVariantIndex?.attributes['item-attributes']?.find(
                    (attr: { name: string }) => attr.name === 'colour',
                  )?.value
                }
                className="ml-2 mr-2 h-6 w-6 object-none"
              />

              {currentVariantIndex?.attributes?.['variant-name'] || currentVariantIndex?.attributes['item-attributes']?.find(
                (attr: { name: string }) => attr.name === 'colour',
              )?.value}

            </div>
          </DropdownButton>
          <DropdownOptions>
            <DropdownOption value="variant">
              <div  className="border-[#828282]  !mt-0 !border-x-2 !border-b-2 pl-3">{renderColorOptions()}</div>
            </DropdownOption>
          </DropdownOptions>
      </Dropdown>
    </>
  );
};

export default VariantSelector;
